



































import { Component, Vue, Prop } from 'vue-property-decorator';
import { NSOffer } from '@/types/Offer';

@Component
export default class JobOfferCard extends Vue {
  @Prop({ type: Number, required: true }) readonly id!: number;
  @Prop({ type: String, required: true }) readonly url!: string;
  @Prop({ type: String, required: true }) readonly title!: string;
  @Prop({ type: String, required: true }) readonly company!: string;
  @Prop({ type: Boolean, required: true }) readonly employee!: boolean;
  @Prop({ type: String, required: true }) readonly job!: string;
  @Prop({ type: String, required: true })
  readonly prefectureLabel!: string;
  @Prop({ type: String, default: '' }) readonly thumbnail_image_url?: string;
  @Prop({ type: String, default: '' }) readonly thumbnail_image_alt?: string;
  @Prop({ type: String, default: '' }) readonly income?: string;
  @Prop({ type: Boolean, required: true })
  readonly recruitment!: NSOffer.RecruitmentStatus;

  /**
   * 「募集」しているか
   */
  public get isRecruitmentHiring(): boolean {
    return this.recruitment;
  }

  /**
   * 「募集終了」しているか
   */
  public get isRecruitmentEnd(): boolean {
    return !this.recruitment;
  }

  /**
   * 正社員求人か
   */
  public get isEmployee(): boolean {
    return this.employee;
  }

  /**
   * 副業か
   */
  public get isNotEmployee(): boolean {
    return !this.employee;
  }
}
